<template>
  <section class="my-0">
    <div class="row mb-3 mx-1 d-flex py-0 my-0 justify-content-end">
      <div
        class="col-sm-5 col-md-12 col-lg-8  col-xl-7  py-1 px-1 text-primary text-left"
      >
        <div class="row justify-content-end" v-if="!isDisable">
          <div class="col-12 d-flex justify-content-end align-items-center">
              <strong class="pt-2 h6">{{
                $t("lang.onBoarding.prospects", {
                  prospects: new Intl.NumberFormat("es-ES").format(
                    apollo.total_result
                  )
                })
              }}</strong>
            <span class="mx-2 h4 pb-0">|</span>
            <img
              :src="imgGraphic"
              width="22px"
              height="31px"
              class="pb-2 img-business"
              alt="business image"
            />
            <div class="text-left ml-2 mt-2 pb-2">
              <div class="text-dark font-size-10">
                <strong>{{ statusText }}</strong>
                <Tooltip class="ml-2" :text="messageToolTip" :width="''">
                  <div
                    class="mt-1 circle bg-secondary d-flex align-items-center justify-content-center"
                  >
                    <div class="question-mark text-white">?</div>
                  </div>
                </Tooltip>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-else>
          <div class="col-12">
            <span
              v-if="isDisable"
              class="loadingres mr-2 ml-2 spinner-border loading-spinner"
            ></span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 ">
      <div>
        <ContactPreview
          :key="contactkey"
          :contacts="apollo.people"
          v-if="apollo.total_result > 0 && !isDisable"
        />
        <LoadingSpinner v-if="isDisable" />
        <div
          v-if="apollo.search_error && !isDisable"
          class="alert alert-warning d-flex align-items-start mb-0"
          role="alert"
        >
          <i class="fas fa-exclamation-triangle mr-2 mt-1"></i>
          <div>
            <strong>{{ $t("lang.label.contact_search_error_title") }}</strong>
            <div class="small mb-0">{{ contactSearchErrorMessage }}</div>
          </div>
        </div>
        <span v-else-if="apollo.total_result == 0 && !isDisable">
          {{ $t("lang.label.contact_search_no_contacts") }}
        </span>
      </div>
    </div>
    <div class="row" v-if="$store.state.onboarding.apollo.total_result > 0">
      <div class="col-12  text-center mt-4">
        <button class="btn btn-primary btn-sm" @click="getApollo()">
          {{ $t('lang.orders.refresh_contacts') }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import ContactPreview from "@/components/Contacts/ContactPreview.vue";
import { mapState, mapActions } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Tooltip from "@/components/Common/Tooltip.vue";
import { formatContactSearchError } from "@/_helpers/salesridgeSearchError";

export default {
  data() {
    return {
      valueUpdated: true,
      text2: ""
    };
  },
  computed: {
    ...mapState({
      apollo: state => state.onboarding.apollo,
      isDisable: state => state.onboarding.isDisable
    }),
    statusText() {
      if (this.apollo.total_result < 3000) {
        return "Too small";
      } else if (this.apollo.total_result < 10000) {
        return "Good";
      } else {
        return "Great!";
      }
    },
    imgEmoticon() {
      if (this.apollo.total_result < 3000) {
        return require("@/assets/images/too_small_emoticon.png");
      } else if (this.apollo.total_result < 10000) {
        return require("@/assets/images/ok.png");
      } else {
        return require("@/assets/images/start.png");
      }
    },
    imgGraphic() {
      if (this.apollo.total_result < 3000) {
        return require("@/assets/images/too_small.png");
      } else if (this.apollo.total_result < 10000) {
        return require("@/assets/images/good.png");
      } else {
        return require("@/assets/images/great.png");
      }
    },
    messageToolTip() {
      if (this.apollo.total_result < 5000) {
        return this.$t("lang.orders.too_low");
      } else if (this.apollo.total_result < 10000) {
        return this.$t("lang.orders.good");
      } else {
        return this.$t("lang.orders.great");
      }
    },
    contactSearchErrorMessage() {
      return formatContactSearchError(this.$i18n, this.apollo.search_error);
    },
  },

  created() { 
    if (this.simplify) {
      this.apolloData(this.contacts);

     
    }else{
      //this.getApollo()
    }
  },

  methods: {
    ...mapActions("onboarding", {
      apolloData: "apolloData",
      getApollo: "getApollo"
    })
  },
  props: {
    contacts: {},
    contactkey: Number,
    simplify: {
      default: false,
      type: Boolean
    }
  },
  components: { ContactPreview, LoadingSpinner, Tooltip }
};
</script>
<style scoped>
.circle {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 10px;
}
.font-size-10 {
  font-size: 10px;
}

.border-color-gray {
  border-left: 1px solid gray;
}
</style>
